import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>({
  containerSkeleton: {
    display: 'flex',
    flexDirection: 'column'
  }
})
